import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VimeoService {

  constructor(
    private _http: HttpClient
  ) { }

  public getVimeoThumbnail(vimeoId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/vimeo/' + vimeoId + '/thumbnail').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getVimeoVideo(vimeoId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/vimeo/' + vimeoId + '/video').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public massUpdateThumbnails(){
    return this._http.get(environment.apiEndpoint+'/api/admin/vimeo/massUpdateThumbnails').pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
